module.exports = __webpack_public_path__ + "img/@logo_skhynix@3x.2ec66099.png";